module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"section_title":"Settings","saved_settings":"Settings have been saved"},"ua":{"section_title":"Налаштування","saved_settings":"Налаштування збережені"},"ru":{"section_title":"Настройки","saved_settings":"Настройки сохранены"}}')
  delete Component.options._Ctor
}
